import './Inventory.scss';
import Component from './Inventory.js';
export default Component;
